/**
 * Console tracking provider for local development and debugging
 */

import type {
  TrackingProvider,
  UserProperties,
  GroupProperties,
} from '../types'

export function createConsoleProvider(): TrackingProvider {
  return {
    name: 'console',

    async init(): Promise<void> {
      console.info('[track:console] initialized')
    },

    async reset(): Promise<void> {
      console.info('[track:console] identity reset')
    },

    async track(
      eventName: string,
      properties: Record<string, unknown>
    ): Promise<void> {
      console.info('[track:console]', eventName, properties)
    },

    async identify(userId: string, properties?: UserProperties): Promise<void> {
      console.info('[track:console] identify', { userId, ...properties })
    },

    async setGroup(
      groupKey: string,
      groupId: string | string[]
    ): Promise<void> {
      console.info('[track:console] setGroup', { groupKey, groupId })
    },

    async identifyGroup(
      groupKey: string,
      groupId: string,
      properties?: GroupProperties
    ): Promise<void> {
      console.info('[track:console] identifyGroup', {
        groupKey,
        groupId,
        ...properties,
      })
    },

    async clearGroup(groupKey: string): Promise<void> {
      console.info('[track:console] clearGroup', { groupKey })
    },
  }
}
